export default (async () => {
  const response = await fetch(`/applicationConfig.json?cache=${new Date().getTime()}`, { // forward slash makes it fetch relative to root
    headers: { Accept: 'application/json' },
    credentials: 'same-origin',
  })
  return response.json()
})()
